import { reactive } from 'vue';
import { IIncentiveV2State, IIncentiveV2StoreDependencies } from '@/domain/dto/store.incentive-v2.interfaces';
import { IncentiveStep, PortalType } from 'interfaces';

/* Fresh reactive state on every call, the factory pattern already proven by createIncentiveStore()/
	createFlowStore(). Each mounted Incentive app gets its own instance, never a shared module-level
	object. See docs/incentive-architecture.md section 4.2. */
const createIncentiveV2State = (dependencies: IIncentiveV2StoreDependencies): IIncentiveV2State => {
	return reactive({
		step: dependencies.initialStep ?? IncentiveStep.REGISTRATION,
		location: dependencies.location,
		incentiveType: dependencies.incentiveType,
		uniqueIdentifier: dependencies.uniqueIdentifier,
		portalType: dependencies.portalType || PortalType.MASTERS,
		name: null,
		email: null,
		password: null,
		confirmPassword: null,
		accessToken: null,
		pending: false,
		errorMessage: { message: null, type: null },
	});
};

export { createIncentiveV2State };
